import React from 'react';

import { DateField } from './Field/DateField';
import { DeclarationType } from '../../../../service/constants';
import { InputField } from './Field/InputField';
import { SectionTitle } from './Field/SectionTitle';
import { getFieldProps } from '../tools';

const Input = {
    [DeclarationType.DATE]: (props) => <DateField {...props} />,
    [DeclarationType.NUMBER]: (props) => <InputField {...props} />,
    [DeclarationType.LABEL]: (props) => <SectionTitle {...props} />,
    [DeclarationType.TEXT]: (props) => <InputField {...props} />,
};

const Fields = ({ type, fieldsProps }) => {
    // на старом бэке тип 'text' используется для названия, а тип для поля 'text' не указывается
    if (type === DeclarationType.TEXT) {
        type = DeclarationType.LABEL;
    }

    if (type === undefined) {
        type = DeclarationType.TEXT;
    }

    const fieldProps = React.useMemo(() => {
        return getFieldProps(type, fieldsProps);
    }, [type, fieldsProps]);

    return Input[type.toLowerCase()](fieldProps);
};

export { Fields };
